import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const STORAGE_KEY = "ecowallet_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice, at: new Date().toISOString() })
    );
    setVisible(false);
    // Fire an initial PAGE_VIEW immediately after consent so the current
    // page isn't lost (route tracker only fires on subsequent changes).
    if (choice === "accepted") {
      try { trackEvent("PAGE_VIEW", { meta: { first_after_consent: true } }); } catch {}
    }
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:bottom-6 sm:max-w-md z-[60] card-premium p-5 shadow-2xl animate-in slide-in-from-bottom-4"
      role="dialog"
      aria-live="polite"
      data-testid="cookie-consent-banner"
    >
      <button
        onClick={() => decide("dismissed")}
        className="absolute top-3 right-3 p-1 rounded-full hover:bg-muted transition-colors"
        aria-label="Close"
        data-testid="cookie-close"
      >
        <X className="h-4 w-4" />
      </button>

      <div className="flex items-start gap-3">
        <div className="grid place-items-center h-10 w-10 rounded-full bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300 shrink-0">
          <Cookie className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h3 className="font-bold text-sm">We use cookies</h3>
          <p className="mt-1 text-xs text-muted-foreground leading-relaxed">
            Ecowallet uses essential cookies for authentication and optional analytics to improve your experience.
            Read our{" "}
            <Link to="/privacy" className="text-primary font-semibold hover:underline">Privacy Policy</Link>.
          </p>
        </div>
      </div>

      <div className="mt-4 flex items-center gap-2">
        <button
          onClick={() => decide("declined")}
          className="btn-pill flex-1 border border-border bg-card text-sm py-2 hover:bg-muted"
          data-testid="cookie-decline"
        >
          Decline
        </button>
        <button
          onClick={() => decide("accepted")}
          className="btn-pill flex-1 bg-primary text-primary-foreground text-sm py-2"
          data-testid="cookie-accept"
        >
          Accept all
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
